import React, { useEffect } from 'react'
import CheckIcon from '../../../../components/icons/CheckIcon'
import { Box, Typography, getContrastRatio } from '@mui/material'
import { useDispatch, useSelector } from 'react-redux'
import duplicatingFilesImage from '../../../../assets/importPopup.svg'
import { useState } from 'react'
import { updateState } from '../../../../redux/commonSlice'
import CustomAlert from '../../../events/components/CustomAlert'
import CustomInput from '../../../eventcreation/components/CustomInput'
import { updateAppleSignState } from '../../../../redux/appleSignSlice'
import useValidator from '../../../../hooks/useValidator'
import { gaEvents } from '../../../../ga/actions'
import { afterValidate, generateLighterContrastColor, setInput } from '../../../../utils/commonServices'
import { LoadingButton } from '@mui/lab'
import useAppleSignup from '../hooks/useAppleSignup'
// import { customTheme as theme } from '../../../../theme/customTheme'
import useCustomTheme from '../../../../theme/useCustomTheme'
import { useNavigate } from 'react-router-dom'
import movieIcon from '../../../../assets/movieIcon.svg';



const SignupWithApplePopup = (props) => {

    const {importFilesStatus, } = props
    const [theme ] = useCustomTheme()
    const [signApple, signAppleStatus] = useAppleSignup();
    let payload = {};
    const  navigate = useNavigate();
    const appleSignReducer = useSelector((state) => state.appleSignReducer);
    const [pageData, setPageData] = useState({
      name: appleSignReducer.apple_response.name ? appleSignReducer.apple_response.name : "" ,
      company_name: appleSignReducer.apple_response.company_name ,
      phone_number: appleSignReducer.apple_response.phone_number ? appleSignReducer.apple_response.phone_number : "",
      email: appleSignReducer.apple_response.email?.includes('@privaterelay.appleid.com') ? "" : appleSignReducer.apple_response.email ,
     // apple_token: appleSignReducer.apple_response.email,
      
    })
    // const [pageData, setPageData] = useState({
    //   name: "" ,
    //   company_name: "" ,
    //   phone_number: "",
    //   email:  "" ,
    //  // apple_token: appleSignReducer.apple_response.email,
      
    // })
    const [errorObjectArray, checkEmptyFields, checkValue] = useValidator(pageData);
    const dispatch = useDispatch()
   

    const handleClose = () => {
        dispatch(updateAppleSignState({signup_with_apple_popup : false}))
       };

    const submitClickHandler = (event) => {
      // setSnackbarProps({type: "success", flag: true, message: "Test snackbar"})
      // console.log("button", event.type)
      payload = {
        full_name: pageData.name,
        company_name: pageData.company_name ,
        phone_number: pageData.phone_number,
        email: pageData.email,
        apple_token: appleSignReducer.apple_response.email
      }
      
      checkEmptyFields(event);
      checkValue(event);
      afterValidate(afterValidatCallback);
    };
  
    const afterValidatCallback = async () => {
     // gaEvents.joinClicked();
      await signApple(pageData);
    };

    useEffect(()=> {

      
        if(signAppleStatus == "check_mail") {
          navigate('/resendlink', {state: {pageData: {email: ""}, title: 'Your email verification is pending', icon: movieIcon, btnText: 'Resend Email', message:'Please check your email and click on the verify now button to continue.', signIn: false}, replace:true})
        }
      
  
    }, [signAppleStatus])

  return (
    <CustomAlert
    open={appleSignReducer?.signup_with_apple_popup}
    handleClose={handleClose}
    height='400px'
    // rightComponent={
    //     <Box  sx={{ paddingX:{xs:'0.5rem',md:'1rem', lg:'1.2rem', xl:'2rem'},height:'100%', display:'grid', placeItems:'center', }}>
    //        <Box sx={{height:'50%'}}  className= 'flex col j-center a-center' mt={{xs:5,sm:0}}> 
    //             <img src={duplicatingFilesImage} style={{maxWidth: '200px', width:'100px'}} height='100%'/>
    //        </Box>
    //      </Box>
    //     }
    >
        <Box sx={{display:'flex', flexDirection:'column', height:'100%'}}  px={5} pt={5} pb={5.8}>
    

            {/* box to be displayed in files duplicating state */}
            <Box flexGrow={1} gap={2} sx={{width:{xs:'100%', sm:'80%', md:'60%'}}}>
                <Typography pb={3} sx={{fontWeight:600, fontFamily:'Rubik', fontSize:{xs:'16px',sm:'16px',md:'18px',lg:'20px',xl:'30px'}}}>Enter Your Details</Typography>
                
             
                <CustomInput
              id={errorObjectArray[0]?.id}
              onFocus={checkEmptyFields}
              onBlur={checkValue}
              disabled = {appleSignReducer.apple_response.name ? true : false }
              required
              errorFlag={errorObjectArray[0]?.errorFlag}
              errorMsg={errorObjectArray[0]?.error}
              type="text"
              max={40}
              placeholder="Name"
              onChange={(event) => {
                setInput(
                  pageData?.name != ""
                    ? event.target.value
                    : event.target.value.trim(),
                  "name",
                  pageData,
                  setPageData
                );
                checkEmptyFields(event);
              }}
              value={pageData?.name}
            />
             <CustomInput
              id={errorObjectArray[1]?.id}
              onFocus={checkEmptyFields}
              onBlur={checkValue}
            //  required
            //  errorFlag={errorObjectArray[1]?.errorFlag}
            //  errorMsg={errorObjectArray[1]?.error}
              type="text"
              max={40}
              placeholder="Company Name"
              onChange={(event) => {
                setInput(
                  pageData?.company_name != ""
                    ? event.target.value
                    : event.target.value.trim(),
                  "company_name",
                  pageData,
                  setPageData
                );
                checkEmptyFields(event);
              }}
              value={pageData?.company_name}
            />
            <CustomInput
              id={errorObjectArray[2]?.id}
              onFocus={checkEmptyFields}
              onBlur={checkValue}
              // required
              // errorFlag={errorObjectArray[2]?.errorFlag}
              // errorMsg={errorObjectArray[2]?.error}
              // label="Phone Number"
              type="text"
              max={10}
              placeholder="Phone Number"
              onChange={(event) => {
                !isNaN(event.target.value) &&
                  setInput(
                    event.target.value.trim(),
                    "phone_number",
                    pageData,
                    setPageData
                  );
                checkEmptyFields(event);
              }}
              value={pageData?.phone_number}
            />
            <CustomInput
              id={errorObjectArray[3]?.id}
              onFocus={checkEmptyFields}
              onBlur={checkValue}
              disabled = {appleSignReducer.apple_response.email.includes('@privaterelay.appleid.com') ? false : true}
              required
              errorFlag={errorObjectArray[3]?.errorFlag}
              errorMsg={errorObjectArray[3]?.error}
              // label="Email Address*"
              type="text"
              max={40}
              placeholder="Email Address*"
              onChange={(event) => {
                setInput(
                  pageData?.email != ""
                    ? event.target.value
                    : event.target.value.trim(),
                  "email",
                  pageData,
                  setPageData
                );
                checkEmptyFields(event);
              }}
              value={pageData?.email}
            />
            </Box>

            { signAppleStatus == 'loading' || signAppleStatus == 'success' ? <LoadingButton
                   // size="small"
                    sx={{
                        '& .MuiLoadingButton-loadingIndicator': {
                            color: theme.palette.primary.main,
                        },
                        height: {xs:'36px',sm:'40px',md:'45px', lg:'51px',xl:'75px'},
                       minWidth: {xs:'36px !important',sm:'40px !important',md:'45px !important', lg:'51px !important',xl:'75px !important'},
                        backgroundColor: '#08231B'
                    }}
                    loading={signAppleStatus == 'loading'}
                    variant="outlined"
                    disabled
                    >
                   
               </LoadingButton> :
               <CheckIcon color={theme.palette.primary.main === ('#00d744' || '#00D744') ? '#00d744' :  getContrastRatio('#08231B', theme.palette.primary.main) > 4.5 ? `${theme.palette.primary.main}` : generateLighterContrastColor(theme.palette.primary.main)} onClick= {submitClickHandler}  sx={{fontSize:{xs:'40px',sm:'44px',md:'50px', lg:'56px',xl:'82px'}, cursor: 'pointer'}}/>
               }
          
            {/* <Box sx={{display:'flex', flexDirection:'column', justifyContent:'flex-end', alignItems:'end'}} pr={1.5}>
                <CheckIcon onClick={submitClickHandler}  sx={{fontSize:{xs:'40px',sm:'44px',md:'50px', lg:'56px',xl:'82px'}, cursor:  'pointer', }}/>
            </Box> */}
           
        </Box>
    </CustomAlert>
  )
}

export default SignupWithApplePopup